import { render, staticRenderFns } from "./OpenService.vue?vue&type=template&id=31612c42&"
import script from "./OpenService.vue?vue&type=script&lang=ts&"
export * from "./OpenService.vue?vue&type=script&lang=ts&"
import style0 from "./OpenService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports